<!-- src/components/SectionBlock.vue -->
<template>
  <div class="core-section section-block">
    <h6 class="core-section-title blue-grey-text text-darken-3">
      {{ title }}
    </h6>

    <div class="core-divider"></div>

    <div v-for="item in items" :key="item.key" class="row question-row">
      <div class="col s12 m7">
        <div class="question-label" v-html="item.label"></div>
      </div>

      <div class="col s12 m5">
        <div class="radio-wrap">
          <label class="radio-pill">
            <input
              class="with-gap"
              type="radio"
              :name="`audit-${item.key}`"
              value="A"
              :checked="modelValue[item.key] === 'A'"
              @change="setAnswer(item.key, 'A')"
            />

            <span>Yes</span>
          </label>

          <label class="radio-pill">
            <input
              class="with-gap"
              type="radio"
              :name="`audit-${item.key}`"
              value="B"
              :checked="modelValue[item.key] === 'B'"
              @change="setAnswer(item.key, 'B')"
            />

            <span>No</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },

  items: {
    type: Array,
    required: true,
  },

  modelValue: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue"]);

function setAnswer(key, value) {
  emit("update:modelValue", {
    ...props.modelValue,
    [key]: value,
  });
}
</script>

<style scoped>
.section-block {
  min-width: 0;
}

.question-row {
  min-width: 0;
  margin-bottom: 10px;
}

.question-label {
  font-size: 14px;
  color: #37474f;
  line-height: 1.35;
}

.radio-wrap {
  display: flex;
  gap: 18px;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.radio-pill {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
}

[type="radio"]:checked + span:after,
[type="radio"].with-gap:checked + span:before,
[type="radio"].with-gap:checked + span:after {
  border: 2px solid #78909c;
}

[type="radio"]:checked + span:after,
[type="radio"].with-gap:checked + span:after {
  background-color: #78909c;
}

@media (max-width: 600px) {
  .question-row {
    margin-bottom: 14px;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .question-row:last-child {
    border-bottom: 0;
  }

  .question-label {
    margin-bottom: 8px;
  }

  .radio-wrap {
    width: 100%;
    gap: 10px;
  }

  .radio-pill {
    flex: 1 1 calc(50% - 5px);
    min-height: 40px;

    border: 1px solid #cfd8dc;

    border-radius: 10px;

    padding: 4px 10px;

    background: #fafafa;
  }

  .radio-pill span {
    width: 100%;
  }
}
</style>
